<template>
  <div>
    <v-col v-if="list.length > 0">
      <carousel
        :per-page-custom="[
          [320, 1],
          [960, 2],
          [1264, 3],
          [1904, 4],
        ]"
        autoplay
        loop
        :pagination-enabled="false"
      >
        <slide
          v-for="(item, i) in list"
          :key="i"
        >
          <img
            :src="'/storage/' + item.image"
            :lazy-src="'/storage/' + item.image"
            style="width: 100%; height: 100%"
            @click="showModel(item)"
          >
        </slide>
      </carousel>
      <!-- Show dialog  -->
      <v-dialog
        v-model="show"
        persistent
        max-width="500"
      >
        <v-card class="pa-0">
          <v-card-title>
            <small> Added at {{ activeItem.created_at }}</small> <v-spacer />
            <v-btn
              class="mx-2 error--text"
              icon
              @click="show = false"
            >
              <v-icon>mdi-close-octagon</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p>
              <strong>Description : {{ activeItem.title }} </strong>
            </p>
            <v-img
              :src="'/storage/' + activeItem.image"
              :lazy-src="'/storage/' + activeItem.image"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end -->
    </v-col>
    <v-col v-else>
      <v-alert type="info">
        Recored not found !
      </v-alert>
    </v-col>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      list: [],
      activeItem: {},
      show: false,
    };
  },

  mounted() {
    window.axios.get("/get-gallery-items").then((response) => {
      this.$data.list = response.data.list;
    });
  },
  methods: {
    showModel(item) {
      this.$data.activeItem = item;
      this.$data.show = true;
    },
  },
};
</script>
